define("Magento_Catalog/js/view/image",["uiComponent"],function(e){"use strict";return e.extend({initialize:function(){this._super(),this.template=window.checkout.imageTemplate||this.template}})});
